import type { ClientListItem } from "@/domain/clients/list-types";
import {
  CORPORATION_CLIENT_ENTITY,
  INDIVIDUAL_CLIENT_ENTITY,
} from "@/shared/events/entity-invalidation";
import { DOCK_PATHS } from "@/shared/ui/dock-pages";
import type { ChatContext } from "@/shared/ui/WorkspaceContext";

export function viewFrontendContext(
  workspaceContext: ChatContext | null,
  pathname: string,
  clientRows: readonly ClientListItem[] | null,
): ViewTurnContext | null {
  if (workspaceContext) return fromWorkspace(workspaceContext);
  return clientCardContext(pathname, clientRows);
}

function fromWorkspace(context: ChatContext): ViewTurnContext | null {
  const entities = context.entities
    .map((entity) => ({ id: sendable(entity.id), type: sendable(entity.type) }))
    .filter((entity): entity is ViewEntity => entity.id !== null && entity.type !== null);
  if (entities.length === 0) return null;
  const section = sendable(context.viewedSection ?? null);
  return section ? { viewed_section: section, entities } : { entities };
}

function clientCardContext(
  pathname: string,
  clientRows: readonly ClientListItem[] | null,
): ViewTurnContext | null {
  const match = CLIENT_CARD.exec(pathname);
  if (!match || !clientRows) return null;
  const routeId = decodeURIComponent(match[1] ?? "");
  const row = clientRows.find((candidate) => candidate.id === routeId);
  if (!row) return null;
  const entity: ViewEntity | null =
    row.kind === "corporation"
      ? { id: row.id, type: CORPORATION_CLIENT_ENTITY }
      : row.icId
        ? { id: row.icId, type: INDIVIDUAL_CLIENT_ENTITY }
        : null;
  return entity ? { viewed_section: CLIENT_CARD_SECTION, entities: [entity] } : null;
}

function sendable(raw: string | null): string | null {
  const text = (raw ?? "").trim();
  if (!text || text.length > MAX_HINT) return null;
  return text;
}

interface ViewEntity {
  id: string;
  type: string;
}

export interface ViewTurnContext {
  viewed_section?: string;
  entities: ViewEntity[];
}

const MAX_HINT = 200;

const CLIENT_CARD = new RegExp(`^${DOCK_PATHS.clients}/([^/]+)$`);

const CLIENT_CARD_SECTION = "client_card";
